(async function () {
  // slider
  const thumbs = new Swiper(".mySwiper__thumbs", {
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
  const topGallary = new Swiper(".mySwiper__top-gallary", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbs,
    },
  });

  /*   topGallary.controller.control = thumbs;
  thumbs.controller.control = topGallary; */
  const sizeChartButton = document.getElementById("size-chart");
  const closeChartButton = document.querySelector(".popup--close");
  sizeChartButton.addEventListener("click", function () {
    this.nextElementSibling.style.display = "block";
  });
  closeChartButton.addEventListener("click", function () {
    sizeChartButton.nextElementSibling.style.display = "none";
  });
  const cartResponse = await fetch(routes.cart_url + ".js");
  const cart = await cartResponse.json();
  const ring = cart.attributes.ring;
  const cartAttributes = cart.attributes;
  const ringID = cart.attributes.ring.id;
  const ringSize = cart.attributes.ring.currentRingSize
  const diamondID = cart.attributes.diamond.id;
  const sectionID = document.querySelector("#section-id").value;
  const stepsSectionID = document.querySelector(".diamond-steps").dataset.sectionId;

  let diamondProductData = null;
  await handleCartAttributes();
  const [diamond] = await Promise.all([fetchDiamond(diamondID)], fetch());

  const addToCartBtn = document.querySelector("#add_full-ring_to_cart");
  console.log('addToCartBtn', addToCartBtn);

  const diamondImages = document.querySelectorAll(".fullring__diamond-image");
  const diamondImagesContainer = document.querySelectorAll(".swiper-slide.diamond-image");
  const diamondvideo = document.querySelector("#diamond-featured-video");
  const diamondVideoContainer = document.querySelectorAll(".swiper-slide.diamond-video");

  const diamondPrice = document.querySelector(".diamond-price");
  const finalPrice = document.querySelector("#full-ring-price");

  diamondPrice.innerHTML = wetheme.formatMoney(diamond.GBP_markup_price, wetheme.moneyFormat);
  finalPrice.innerHTML = wetheme.formatMoney(+diamond.GBP_markup_price + +ring.price, wetheme.moneyFormat);

  // set diamond image
  if (diamond.diamond.image) {
    diamondImages.forEach((image) => {
      image.src = diamond.diamond.image;
    });
  } else {
    diamondImagesContainer.forEach((container) => {
      container.remove();
    });
  }

  //set diamond video
  if (diamond.diamond.video) {
    diamondvideo.src = diamond.diamond.video.replace("/500/500", "");
    diamondvideo.removeAttribute("hidden");
  } else {
    diamondVideoContainer.forEach((container) => {
      container.remove();
    });
  }

  async function addFullRingToCart(e) {
    e.preventDefault();
    toggleLoader();
    const shopifyDiamond = await getDiamondVariant(diamondID);
    const sellingPlanInput = document.querySelector("#purchase-option-deposit-input:checked");
    diamond.diamond.certificate.image = diamondImages[0].src;
    diamondAttributes = diamond.diamond.certificate;

    const keyMapping = {
      lab: "Lab",
      certNumber: "Certificate ID",
      carats: "Carat",
      clarity: "Clarity",
      color: "Colour",
    };

    diamondAttributes = Object.keys(diamondAttributes).reduce((acc, key) => {
      // Check if the key is in the mapping; if so, use the mapped key, otherwise keep the original
      const newKey = keyMapping[key] || `_${key}`; // If the key is not in the mapping, add an underscore at the beginning
      acc[newKey] = diamondAttributes[key];
      return acc;
    }, {});

    const diamondData = {
      items: [
        {
          id: shopifyDiamond.variant_id,
          quantity: 1,
          properties: diamondAttributes,
        },
      ],
    };
    const engravingText = (cartAttributes || window.cartAttributes_)?.engravingText || "";
    let engravingFont = (cartAttributes || window.cartAttributes_)?.engravingFont || "";
    const clawStyle = (cartAttributes || window.cartAttributes_)?.clawStyle || "";
    engravingFont = engravingText ? engravingFont : "";
    const ringData = {
      items: [
        {
          id: ring.id,
          quantity: 1,
          properties: {
            "Finger size": ringSize,
            _diamond: shopifyDiamond.variant_id,
            _shape: cart.attributes.diamond?.shape || ring.shape || '',
            'Engraving text': engravingText,
            'Engraving font': engravingFont,
            'Claw style': clawStyle,
          },
        },
      ],
      // reset cart attributes
      attributes: {
        engravingFont: "",
        engravingText: "",
        clawStyle: "",
      },
    };
    if (sellingPlanInput) {
      const prodDiamond = await getProductBySku(diamondID);
      const prod = await getProduct(prodDiamond.handle);
      prod && (sellingPlanInput.dataset.diamondSellingPlanId = prod.variants[0].selling_plan_allocations[0].selling_plan_id);
      ringData.items[0].selling_plan = sellingPlanInput.dataset.ringSellingPlanId;
      diamondData.items[0].selling_plan = sellingPlanInput.dataset.diamondSellingPlanId;
    }

    try {
      // update cart ring and diamond to 0
      const updatedData = {
        updates: {
          [shopifyDiamond.variant_id]: 0,
          [ring.id]: 0,
        },
      };
      await handleUpdateCart(updatedData);

      // add diamond to cart
      const postedDiamond = await handleAddToCart(diamondData);

      if (postedDiamond.status) {
        const data = {
          attributes: {
            diamond: "",
            diamond: "",
          },
        };
        // delete diamond from cart attributes
        await handleDeleteFromCart(data);

        confirm(`Error adding diamond to cart, ${postedDiamond.description}`);
        return location.reload();
      }

      // add ring to cart
      const postedRing = await handleAddToCart(ringData);

      if (postedRing.status) {
        const data = {
          attributes: {
            ring: "",
          },
        };
        // delete ring from cart attributes
        await handleDeleteFromCart(data);

        confirm(`Error adding ring to cart, ${postedRing.description}`);
        return location.reload();
      }

      window.location = e.target.dataset.href;
    } catch (error) {
      toggleLoader();
      console.log(error.message);
    }
  }

  async function getDiamondVariant(diamondId) {
    if (diamondProductData && diamondProductData.variant_id) return diamondProductData;
    try {
      const res = await fetch(`${window.HPDiamondsAppURL}/products/check/${diamondId}`);
      const data = await res.json();
      diamondProductData = data;
      return data;
    } catch (error) {
      console.log(error);
    }
  }
  async function fetchDiamond(id) {
    toggleLoader();
    try {
      const res = await fetch(`${window.HPDiamondsAppURL}/diamonds/${id}`);
      const diamond = await res.json();
      toggleLoader();
      return diamond.diamond;
    } catch (error) {
      toggleLoader();
      console.log(error);
    }
  }

  async function getProduct(productHandle) {
    const res = await fetch(`/products/${productHandle}.js`);
    const data = await res.json();
    return data;
  }

  async function getProductBySku(sku) {
    try {
      const res = await fetch(`${window.HPDiamondsAppURL}/products/${sku}`);
      const { product } = await res.json();
      return product;
    } catch (error) {
      console.log(error);
    }
  }

  async function handleUpdateCart(data) {
    try {
      const resp = await fetch(window.routes.cart_update_url + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const info = await resp.json();
      return info;
    } catch (e) {
      console.log(e);
    }
  }
  async function handleAddToCart(data) {
    const resp = await fetch(window.routes.cart_add_url + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => response.json());

    return resp;
  }

  async function handleDeleteFromCart(data) {
    await fetch("/cart.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json;",
      },
      body: JSON.stringify(data),
    });
  }

  async function handleCartAttributes() {
    const { diamond, ring } = cartAttributes;
    if (typeof diamond === "string" || typeof ring === "string") {
      console.log("strings");
      const attributes = { attributes: JSON.parse(localStorage.getItem("cartAttributes")) };
      window.cartAttributes_ = attributes.attributes;
      await handleUpdateCart(attributes);
      sectionRendering(sectionID);
      sectionRendering(stepsSectionID);
      return;
    }
  }

  function sectionRendering(sectionId) {
    console.log("rendering");
    toggleLoader();
    fetch(window.Shopify.routes.root + `?section_id=${sectionId}`)
      .then((res) => res.text())
      .then((data) => {
        const fullRingSection = document.querySelector(`#shopify-section-${sectionId}`);
        fullRingSection.innerHTML = data;
        fullRingSection.scrollIntoView({ behavior: "smooth" });
        toggleLoader();
      });
  }

  addToCartBtn.addEventListener("click", addFullRingToCart);
})();
